module.exports = __webpack_public_path__ + "static/media/edit_profile.740d2356.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/icons/old/edit_profile.png
// module id = 564
// module chunks = 0